import type { IInvoice } from "../../create/interfaces/invoice.interfaces";

/** Net amount to charge after deposit credit, plus optional client tip (same as backend getNetInvoiceChargeAmount). */
export function getInvoiceNetDueAfterDeposit(invoice: IInvoice | Record<string, unknown> | null | undefined): number {
  if (!invoice) return 0;
  const inv = invoice as IInvoice;
  const gross = Number(inv.totalCost?.total?.value ?? 0);
  const credit = Number(inv.creditedDepositAmount ?? 0);
  const tip = Number(inv.tipAmount ?? inv.pricingDetail?.tip?.amount ?? 0);
  const g = Number.isFinite(gross) ? gross : 0;
  const c = Number.isFinite(credit) && credit > 0 ? credit : 0;
  const t = Number.isFinite(tip) && tip > 0 ? tip : 0;
  return Math.max(0, Math.round((g - c + t) * 100) / 100);
}

/**
 * Invoice is paid with nothing left to charge online because deposit credit covered the balance
 * (backend skips PayPal/Stripe and records paidWithPaymentMethod as manual_entry).
 */
export function isBalanceFullyCoveredByDeposit(invoice: IInvoice | Record<string, unknown> | null | undefined): boolean {
  if (!invoice || !(invoice as IInvoice).paidAt) return false;
  const credit = Number((invoice as IInvoice).creditedDepositAmount ?? 0);
  if (!(credit > 0)) return false;
  return getInvoiceNetDueAfterDeposit(invoice) === 0;
}
